import { derived, get, writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';

const STORAGE_KEY = 'shelly_dev_force_list_skeleton';

const readInitialValue = (): boolean => {
	if (!isNonProductionAppBuild()) return false;
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

/**
 * Dev/staging: force Home list / gallery skeleton screens so we can preview
 * loading chrome without waiting on real data. Always off in production.
 */
export const forceListSkeletonEnabled = writable<boolean>(readInitialValue());

forceListSkeletonEnabled.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const forceListSkeleton = derived(
	forceListSkeletonEnabled,
	($enabled) => isNonProductionAppBuild() && $enabled,
);

export const isForceListSkeleton = (): boolean => get(forceListSkeleton);

export const setForceListSkeletonEnabled = (enabled: boolean) => {
	forceListSkeletonEnabled.set(isNonProductionAppBuild() ? enabled : false);
};

/** Default placeholder count when forcing / mounting list skeletons (≈ viewport fill). */
export const LIST_SKELETON_COUNT = 9;
